import moment from "moment";

export default class UserModel {
    constructor() {
        this.id = undefined;
        this.firstName = '';
        this.lastName = '';
        this.subcontractor = undefined;
        this.loginAllowed = false;
        this.email = '';
        this.phoneNumber = '';
        this.phoneNumber = '';
        this.status = {enumValue: 'ACTIVE', label: 'Aktywny'};
        this.contract = {price: {}, cost: {}};
        this.contracts = [];
        this.absences = [];
        this.alarms = [];
        this.documents = [];
        this.categories = [];
        this.link = '';
        this.createDate = undefined;
        this.externalManager = undefined;
        this.roles = [];
        this.annualLeaves = {};
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id ? from.id : undefined;
            to.loginAllowed = from?.loginAllowed ? from.loginAllowed : false;
            to.firstName = from.firstName ? from.firstName : '';
            to.lastName = from.lastName ? from.lastName : '';
            to.subcontractor = from.subcontractor ? from.subcontractor : null;
            to.email = from.email ? from.email : '';
            to.link = from.link ? from.link : '';
            to.phoneNumber = from.phoneNumber ? from.phoneNumber : '';
            to.externalManager = from.externalManager;
            const status = {enumValue: 'ACTIVE', label: 'Aktywny'};
            to.status = from.status ? from.status : status;
            to.contracts = from.contracts;
            to.categories = from.categories;
            to.absences = from.absences;
            to.alarms = from.alarms;
            to.documents = from.documents;
            to.roles = from.roles;
            to.annualLeaves = from.annualLeaves;
            if(to.absences){
                to.absences.forEach((c)=>{
                    if (c.dateFrom) {
                        c.dateFrom = new Date(c.dateFrom);
                    }
                    if (c.dateTo) {
                        c.dateTo = new Date(c.dateTo);
                    }
                })
            }
            if(to.documents){
                to.documents.forEach((d)=>{
                    if (d.dateTo) {
                        d.dateTo = new Date(d.dateTo);
                    }
                })
            }
            if (to.contracts) {
                to.contracts.forEach((c) => {
                    if (c.dateFrom) {
                        c.dateFrom = new Date(c.dateFrom);
                    }
                    if (c.dateTo) {
                        c.dateTo = new Date(c.dateTo);
                    }
                });
            }
            to.contract = from.contract;
            to.createDate = from.createDate;
            if (to.contracts) {
                to.contracts.forEach((c) => {
                    if (c.dateFrom) {
                        c.dateFrom = moment(c.dateFrom).toDate();
                    }
                });
            }
        } else {
            to = new UserModel();
        }
    }

    static copy(from) {
        const to = new UserModel();
        UserModel.assign(from, to);
        return to;
    }
}
